var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSolutionsImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 325,
    height: 200,
    viewBox: "0 0 325 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_62",
    "data-name": "Group 62",
    transform: "translate(-30 -20)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63",
    "data-name": "Group 63",
    transform: "translate(30 20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1203",
    "data-name": "Path 1203",
    d: "M1005.486,478.724H995.57a1.363,1.363,0,0,1-1.1-.579,1.6,1.6,0,0,1-.269-1.274,32.052,32.052,0,0,0-.131-13.61,1.567,1.567,0,0,1,.755-1.746c4.142-2.115,7.946-2.06,11.305.163a1.549,1.549,0,0,1,.668,1.072,52.5,52.5,0,0,1,.081,14.657A1.446,1.446,0,0,1,1005.486,478.724Z",
    transform: "translate(-701.168 -356.577)",
    fill: "#419b46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1204",
    "data-name": "Path 1204",
    d: "M1012,491.251h-7.582a.779.779,0,0,1,0-1.552H1012a.779.779,0,0,1,0,1.552Z",
    transform: "translate(-707.827 -376.193)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1205",
    "data-name": "Path 1205",
    d: "M1012,483.251h-7.582a.779.779,0,0,1,0-1.552H1012a.779.779,0,0,1,0,1.552Z",
    transform: "translate(-707.827 -370.915)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_50",
    "data-name": "Ellipse 50",
    cx: 56.391,
    cy: 57.497,
    rx: 56.391,
    ry: 57.497,
    transform: "translate(20.36 6.069)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_51",
    "data-name": "Ellipse 51",
    cx: 9.978,
    cy: 10.887,
    rx: 9.978,
    ry: 10.887,
    transform: "translate(127.887 97.587)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_52",
    "data-name": "Ellipse 52",
    cx: 4.054,
    cy: 4.423,
    rx: 4.054,
    ry: 4.423,
    transform: "translate(212.993 135.011)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1206",
    "data-name": "Path 1206",
    d: "M795.145,553.422c-1.709-14.252-9.894-28.25-22.388-32.8a71.908,71.908,0,0,1,.264,45.468c-1.883,5.668-4.517,11.757-2.682,17.443a14.317,14.317,0,0,0,6.977,7.906,37.832,37.832,0,0,0,9.849,3.228l.665.592C793.085,582.076,796.854,567.675,795.145,553.422Z",
    transform: "translate(-546.801 -396.593)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1207",
    "data-name": "Path 1207",
    d: "M778.895,520.3a59.121,59.121,0,0,1,13.084,31.767,26.568,26.568,0,0,1-.209,7.634,14.436,14.436,0,0,1-3.149,6.507c-1.426,1.732-3.069,3.323-4.085,5.4a9.269,9.269,0,0,0-.342,6.991,22.435,22.435,0,0,0,4.56,7.32c2.036,2.425,4.186,4.909,5.065,8.137.106.391.656.188.55-.2-1.528-5.616-6.553-8.777-8.97-13.829a9.367,9.367,0,0,1-.582-7.6c.9-2.189,2.593-3.832,4.051-5.572a15.29,15.29,0,0,0,3.3-6.237,24.531,24.531,0,0,0,.478-7.6,59.981,59.981,0,0,0-13.365-33.2c-.25-.3-.63.178-.381.478Z",
    transform: "translate(-553.061 -396.004)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1208",
    "data-name": "Path 1208",
    d: "M819.618,585.63a8.455,8.455,0,0,0,5.872-8.938.291.291,0,1,0-.58.036,7.825,7.825,0,0,1-5.478,8.3c-.363.1-.175.7.186.6Z",
    transform: "translate(-580.879 -433.4)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1209",
    "data-name": "Path 1209",
    d: "M796.77,635.474a16.219,16.219,0,0,1-6.754-9.38c-.108-.391-.658-.188-.55.2a16.862,16.862,0,0,0,7.047,9.745C796.836,636.248,797.092,635.68,796.77,635.474Z",
    transform: "translate(-560.382 -466.046)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1210",
    "data-name": "Path 1210",
    d: "M791.824,552.066a4.086,4.086,0,0,1-4.177-.2c-.321-.211-.576.358-.258.568a4.578,4.578,0,0,0,4.62.235.335.335,0,0,0,.182-.4.287.287,0,0,0-.368-.2Z",
    transform: "translate(-558.862 -417.178)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1211",
    "data-name": "Path 1211",
    d: "M658.067,593.219c.2.138.393.275.591.418a58.946,58.946,0,0,1,7.456,6.268c.182.175.365.356.542.536a66.685,66.685,0,0,1,13.4,19.748,68.435,68.435,0,0,1,3.308,9.163c1.226,4.338,2.239,9.149,4.637,12.688a10.956,10.956,0,0,0,.8,1.064l21.477-.15c.049-.027.1-.049.146-.076l.858.037c-.035-.166-.075-.336-.111-.5-.02-.1-.045-.192-.065-.288-.015-.064-.03-.128-.04-.187,0-.021-.01-.043-.015-.059-.01-.059-.025-.112-.035-.165q-.332-1.433-.683-2.867c0-.005,0-.005,0-.011a100.677,100.677,0,0,0-7.474-21c-.1-.2-.2-.4-.307-.6a62.546,62.546,0,0,0-5.141-8.391q-1.584-2.162-3.362-4.142a42.119,42.119,0,0,0-10.477-8.45c-7.729-4.384-16.657-6.022-24.874-3.254C658.483,593.072,658.277,593.143,658.067,593.219Z",
    transform: "translate(-469.964 -443.452)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1212",
    "data-name": "Path 1212",
    d: "M657.666,595.917a50.838,50.838,0,0,1,27.975,16.769,24.483,24.483,0,0,1,4.045,6.233,15.121,15.121,0,0,1,1.076,7.264,31.543,31.543,0,0,0-.28,7,8.622,8.622,0,0,0,3.584,5.807,19.267,19.267,0,0,0,7.68,2.849c2.964.6,6.051,1.17,8.534,3.17.3.242.628-.281.328-.523-4.319-3.48-10.076-2.7-14.793-5.149a8.456,8.456,0,0,1-4.66-5.688c-.489-2.34-.044-4.763.16-7.11a16.181,16.181,0,0,0-.81-7.145,22.833,22.833,0,0,0-3.811-6.38,51.474,51.474,0,0,0-12.208-10.825,50.167,50.167,0,0,0-16.781-6.9c-.366-.077-.4.556-.041.632Z",
    transform: "translate(-469.513 -445.852)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1213",
    "data-name": "Path 1213",
    d: "M739.029,616.268a9.089,9.089,0,0,0-.243-10.994c-.25-.3-.693.106-.443.409a8.415,8.415,0,0,1,.207,10.227A.3.3,0,0,0,739.029,616.268Z",
    transform: "translate(-525.158 -452.377)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1214",
    "data-name": "Path 1214",
    d: "M740.812,676.657a14.084,14.084,0,0,1-10.569-3.052c-.3-.241-.629.282-.328.523a14.646,14.646,0,0,0,11,3.152c.372-.048.262-.67-.107-.623Z",
    transform: "translate(-519.327 -497.49)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1215",
    "data-name": "Path 1215",
    d: "M687.109,607.983a4.427,4.427,0,0,1-3.446,2.582c-.372.043-.262.665.107.623a4.958,4.958,0,0,0,3.818-2.848.347.347,0,0,0-.076-.44.277.277,0,0,0-.4.083Z",
    transform: "translate(-487.42 -454.145)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1216",
    "data-name": "Path 1216",
    d: "M980.332,366.236l-2.9-30.675-.767-12.625,8.13-1.6s1.217,8.679,2.282,13.772c1.051,5.026-1.4,30.458-1.465,31.129a4.586,4.586,0,0,1,1.059,4.756,3.847,3.847,0,0,1-7.389,0,4.587,4.587,0,0,1,1.055-4.757Z",
    transform: "translate(-689.218 -265.108)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1217",
    "data-name": "Path 1217",
    d: "M720.677,540.337h-4.136l-1.968-17.405h6.1Z",
    transform: "translate(-462.784 -345.022)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1218",
    "data-name": "Path 1218",
    d: "M855.842,727.768H842.506v-.184a5.443,5.443,0,0,1,5.19-5.663h0l2.436-2.016,4.545,2.017h1.164Z",
    transform: "translate(-596.894 -528.078)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1219",
    "data-name": "Path 1219",
    d: "M837.575,540.337H833.44l-1.967-17.405h6.1Z",
    transform: "translate(-543.232 -345.022)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1220",
    "data-name": "Path 1220",
    d: "M972.738,727.768H959.4v-.184a5.443,5.443,0,0,1,5.19-5.663h0l2.436-2.016,4.545,2.017h1.164Z",
    transform: "translate(-677.341 -528.078)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1221",
    "data-name": "Path 1221",
    d: "M890.105,454.511l3.479,36.056s4.631,36.1,3.761,41.084.217,5.693.217,5.693l-7.935-.617s.217-3.084-1.087-4.507-.652-5.693-.652-5.693L872.5,467.795l-9.348,30.838s-1.522,33.921-1.739,34.4-.87,6.879-.87,6.879h-8.044s1.087-3.8-.435-4.981-2.826-.237-1.522-2.372,1.739-4.744,1.3-5.93-.435-5.93-.435-5.93.652-64.047,4.348-66.182S890.105,454.511,890.105,454.511Z",
    transform: "translate(-602.053 -352.35)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_53",
    "data-name": "Ellipse 53",
    cx: 8.556,
    cy: 9.335,
    rx: 8.556,
    ry: 9.335,
    transform: "translate(263.024 10.485)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1222",
    "data-name": "Path 1222",
    d: "M978.774,293.488l-8.415,3.293-2.563,1-1.871-26.07,6.42,3.715a.139.139,0,0,1,.028.031,19.143,19.143,0,0,1,2.763,4.473A38.325,38.325,0,0,1,978.774,293.488Z",
    transform: "translate(-681.83 -232.37)",
    fill: "#419b46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1223",
    "data-name": "Path 1223",
    d: "M815.2,364.8s8.552-28.993,8.7-29.34c1.12-9.281,4.342-13.375,4.825-12.931l8.315,3.143s-2.473,8.546-4.148,13.622c-1.6,4.85-12.559,27.244-12.867,27.829a4.611,4.611,0,0,1-.792,4.817,3.717,3.717,0,0,1-4.407.912,4.368,4.368,0,0,1-2.354-4.166A4.276,4.276,0,0,1,815.2,364.8Z",
    transform: "translate(-576.22 -265.878)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1224",
    "data-name": "Path 1224",
    d: "M873.389,274.747s-7.2-3.85-9.992,3.711a90.8,90.8,0,0,0-3.916,12.635s7.338,1.2,9.692,5.726Z",
    transform: "translate(-608.576 -233.725)",
    fill: "#419b46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1225",
    "data-name": "Path 1225",
    d: "M903.067,324.033c-16.569,3.733-38.526-2.685-38.526-2.685l5.857-27.7-2.082-28.992c-.254-3.545,1.6-6.869,4.476-8.047l3.976-1.625,3.286-5.133,9.387.336,3.752,5.389,2.961,1.714,6.42,3.715.028.015v.015l-2.015,21.322-1.215,12.856s3.69,14.459,2.933,16.377-.1.99.085,2.013.746,1.088.831,3.1S903.067,324.033,903.067,324.033Z",
    transform: "translate(-612.058 -217.942)",
    fill: "#419b46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1226",
    "data-name": "Path 1226",
    d: "M908.55,186.727c-.676-.728.342-2.654.149-3.669-.22-1.164-1.4-1.2-1.676-2.346a3.682,3.682,0,0,0-2.623-2.3,15.6,15.6,0,0,0-8.839-.442,31.691,31.691,0,0,0-3.824,1.285c-.863.331-.031-.57-.894-.239a1.354,1.354,0,0,0-.809.586c-.155.32.054.832.381.767l-3.161,1.521,1.773,2.026c-.84-.261-1.736.832-1.4,1.714a1.785,1.785,0,0,0,1.358,1.026c.949.2.229,1.187,1.2,1.168s7.708-2.181,8.178-1.259c.335.656.3,1.526.776,2.067.611.692,1.679.439,2.457-.012a4.236,4.236,0,0,1,2.443-.962c.914.113,1.6,1.955,1.83,2.928a8.162,8.162,0,0,1-.06,2.988c-.188,1.3-2.072,2.6-2.26,3.905,2.09.631,4.333-1.376,5.159-4.866C908.617,190.409,909.99,188.278,908.55,186.727Z",
    transform: "translate(-627.689 -170.231)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1227",
    "data-name": "Path 1227",
    d: "M417.893,440c-25.186,0-47.1-20.5-50.337-48.46l.619-.085c3.2,27.616,24.844,47.863,49.718,47.864a46.171,46.171,0,0,0,6.32-.435c27.436-3.782,46.936-31.211,43.47-61.146l.619-.085c3.509,30.306-16.234,58.078-44.009,61.906a46.857,46.857,0,0,1-6.4.441Z",
    transform: "translate(-299.017 -302.269)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1228",
    "data-name": "Path 1228",
    d: "M507.965,557.626h-9.917a1.363,1.363,0,0,1-1.1-.579,1.6,1.6,0,0,1-.269-1.274,32.043,32.043,0,0,0-.162-13.745,1.588,1.588,0,0,1,.608-1.658c3.431-2.319,7.166-2.246,11.421.222a1.547,1.547,0,0,1,.738,1.114,52.5,52.5,0,0,1,.073,14.6A1.446,1.446,0,0,1,507.965,557.626Z",
    transform: "translate(-387.736 -408.512)",
    fill: "#419b46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1229",
    "data-name": "Path 1229",
    d: "M362.944,385.239h-9.917a1.363,1.363,0,0,1-1.1-.579,1.6,1.6,0,0,1-.269-1.274,32.033,32.033,0,0,0-.173-13.791,1.608,1.608,0,0,1,.546-1.612c5.1-4,9.115-3.885,11.936.346a1.617,1.617,0,0,1,.247.65,52.49,52.49,0,0,1,.124,14.944,1.446,1.446,0,0,1-1.391,1.317Z",
    transform: "translate(-287.927 -293.962)",
    fill: "#419b46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1230",
    "data-name": "Path 1230",
    d: "M509.37,561.5h-3.411a.779.779,0,0,1,0-1.552h3.411a.779.779,0,0,1,0,1.552Z",
    transform: "translate(-393.775 -422.544)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1231",
    "data-name": "Path 1231",
    d: "M513.541,570.516h-7.583a.779.779,0,0,1,0-1.552h7.582a.779.779,0,0,1,0,1.552Z",
    transform: "translate(-393.775 -428.491)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1232",
    "data-name": "Path 1232",
    d: "M369.37,389.5h-3.411a.779.779,0,0,1,0-1.552h3.411a.779.779,0,0,1,0,1.552Z",
    transform: "translate(-297.428 -309.061)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1233",
    "data-name": "Path 1233",
    d: "M369.37,397.5h-3.411a.779.779,0,0,1,0-1.552h3.411a.779.779,0,0,1,0,1.552Z",
    transform: "translate(-297.428 -314.34)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1234",
    "data-name": "Path 1234",
    d: "M369.37,405.5h-3.411a.779.779,0,0,1,0-1.552h3.411a.779.779,0,0,1,0,1.552Z",
    transform: "translate(-297.428 -319.618)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1235",
    "data-name": "Path 1235",
    d: "M739.333,407.061h-31.7a3.364,3.364,0,0,1-3.2-3.5v-21.3a3.364,3.364,0,0,1,3.2-3.5h31.7a3.364,3.364,0,0,1,3.2,3.5v21.3A3.364,3.364,0,0,1,739.333,407.061Z",
    transform: "translate(-501.869 -303.001)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1236",
    "data-name": "Path 1236",
    d: "M732.1,409.638H715.228a3.15,3.15,0,0,1-3-3.274V390.1a3.15,3.15,0,0,1,3-3.274h27.243a3.15,3.15,0,0,1,3,3.274v4.948C745.464,403.1,739.484,409.629,732.1,409.638Z",
    transform: "translate(-507.236 -308.322)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1237",
    "data-name": "Path 1237",
    d: "M750.806,409.989H729a.779.779,0,0,1,0-1.552h21.808a.779.779,0,0,1,0,1.552Z",
    transform: "translate(-518.289 -322.578)",
    fill: "#419b46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1238",
    "data-name": "Path 1238",
    d: "M732.409,419H729a.779.779,0,0,1,0-1.552h3.411a.779.779,0,0,1,0,1.552Z",
    transform: "translate(-518.289 -328.524)",
    fill: "#419b46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1239",
    "data-name": "Path 1239",
    d: "M738.451,428.016H729a.779.779,0,0,1,0-1.552h9.453a.779.779,0,0,1,0,1.552Z",
    transform: "translate(-518.289 -334.471)",
    fill: "#419b46"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_54",
    "data-name": "Ellipse 54",
    cx: 6.706,
    cy: 7.317,
    rx: 6.706,
    ry: 7.317,
    transform: "translate(165.767 68.023)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1240",
    "data-name": "Path 1240",
    d: "M457.431,184.06c1.867-10.34,11.062-17.07,20.539-15.033s15.645,12.07,13.778,22.41l-.612-.131c1.8-9.971-4.148-19.646-13.286-21.611s-18.006,4.526-19.806,14.5Z",
    transform: "translate(-360.868 -164.379)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1241",
    "data-name": "Path 1241",
    d: "M452.126,213.368l-9.908.448a1.352,1.352,0,0,1-1.123-.529,1.6,1.6,0,0,1-.317-1.261,32.033,32.033,0,0,0-.647-13.593,1.578,1.578,0,0,1,.688-1.778c4.058-2.3,7.861-2.417,11.3-.347a1.534,1.534,0,0,1,.708,1.041,52.467,52.467,0,0,1,.637,14.64A1.459,1.459,0,0,1,452.126,213.368Z",
    transform: "translate(-348.923 -181.648)",
    fill: "#419b46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1242",
    "data-name": "Path 1242",
    d: "M459.028,225.5l-7.576.342a.739.739,0,0,1-.74-.743.752.752,0,0,1,.681-.808l7.576-.342a.739.739,0,0,1,.74.743.752.752,0,0,1-.681.808Z",
    transform: "translate(-356.244 -200.853)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1243",
    "data-name": "Path 1243",
    d: "M458.7,217.5l-7.576.342a.739.739,0,0,1-.74-.743.752.752,0,0,1,.681-.808l7.576-.342a.739.739,0,0,1,.74.743A.752.752,0,0,1,458.7,217.5Z",
    transform: "translate(-356.016 -195.58)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1244",
    "data-name": "Path 1244",
    d: "M609.649,184.365h-31.7a3.364,3.364,0,0,1-3.2-3.5v-21.3a3.364,3.364,0,0,1,3.2-3.5h31.7a3.364,3.364,0,0,1,3.2,3.5v21.3A3.364,3.364,0,0,1,609.649,184.365Z",
    transform: "translate(-441.602 -156.069)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1245",
    "data-name": "Path 1245",
    d: "M602.42,186.943H585.543a3.15,3.15,0,0,1-3-3.274V167.409a3.15,3.15,0,0,1,3-3.274h27.243a3.15,3.15,0,0,1,3,3.274v4.948c-.008,8.052-5.988,14.576-13.368,14.585Z",
    transform: "translate(-446.968 -161.391)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1246",
    "data-name": "Path 1246",
    d: "M621.121,187.293H599.313a.779.779,0,0,1,0-1.552h21.808a.779.779,0,0,1,0,1.552Z",
    transform: "translate(-458.021 -175.646)",
    fill: "#419b46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1247",
    "data-name": "Path 1247",
    d: "M602.725,196.307h-3.411a.779.779,0,0,1,0-1.552h3.411a.779.779,0,0,1,0,1.552Z",
    transform: "translate(-458.021 -181.594)",
    fill: "#419b46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1248",
    "data-name": "Path 1248",
    d: "M608.767,205.32h-9.453a.779.779,0,0,1,0-1.552h9.453a.779.779,0,0,1,0,1.552Z",
    transform: "translate(-458.021 -187.54)",
    fill: "#419b46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1262",
    "data-name": "Path 1262",
    d: "M7.3-.121a6.389,6.389,0,0,1,6.873,6.6,7.715,7.715,0,0,1-7.42,7.15,6.389,6.389,0,0,1-6.873-6.6A7.715,7.715,0,0,1,7.3-.121Z",
    transform: "translate(121.767 30.523) rotate(-58.134)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1249",
    "data-name": "Path 1249",
    d: "M1076.521,742.718H755.943c-.551,0-1-.14-1-.313s.446-.313,1-.313h320.574c.551,0,1,.14,1,.313s-.447.313-1,.313Z",
    transform: "translate(-752.514 -542.718)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1250",
    "data-name": "Path 1250",
    d: "M277.869,322.492c-5.729-16.525,1.9-34.989,17.05-41.24s32.068,2.078,37.8,18.6l-.583.241c-5.607-16.174-22.169-24.325-36.993-18.207s-22.294,24.189-16.687,40.363Z",
    transform: "translate(-235.984 -237.292)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1251",
    "data-name": "Path 1251",
    d: "M338.979,276.694h-9.917a1.363,1.363,0,0,1-1.1-.579,1.6,1.6,0,0,1-.269-1.274,32.044,32.044,0,0,0-.155-13.714,1.578,1.578,0,0,1,.642-1.68c3.592-2.281,7.428-2.212,11.4.208a1.537,1.537,0,0,1,.715,1.1,52.5,52.5,0,0,1,.076,14.622A1.446,1.446,0,0,1,338.979,276.694Z",
    transform: "translate(-271.446 -223.181)",
    fill: "#419b46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1252",
    "data-name": "Path 1252",
    d: "M340.37,279.5h-3.411a.779.779,0,0,1,0-1.552h3.411a.779.779,0,0,1,0,1.552Z",
    transform: "translate(-277.47 -236.485)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1253",
    "data-name": "Path 1253",
    d: "M344.541,288.516h-7.583a.779.779,0,0,1,0-1.552h7.582a.779.779,0,0,1,0,1.552Z",
    transform: "translate(-277.47 -242.432)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1254",
    "data-name": "Path 1254",
    d: "M182.649,350.365h-31.7a3.364,3.364,0,0,1-3.2-3.5v-21.3a3.364,3.364,0,0,1,3.2-3.5h31.7a3.364,3.364,0,0,1,3.2,3.5v21.3A3.364,3.364,0,0,1,182.649,350.365Z",
    transform: "translate(-147.744 -265.594)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1255",
    "data-name": "Path 1255",
    d: "M175.42,352.943H158.543a3.15,3.15,0,0,1-3-3.274V333.409a3.15,3.15,0,0,1,3-3.274h27.243a3.15,3.15,0,0,1,3,3.274v4.948C188.779,346.409,182.8,352.934,175.42,352.943Z",
    transform: "translate(-153.11 -270.915)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1256",
    "data-name": "Path 1256",
    d: "M194.121,353.293H172.313a.779.779,0,0,1,0-1.552h21.808a.779.779,0,0,1,0,1.552Z",
    transform: "translate(-164.163 -285.171)",
    fill: "#419b46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1257",
    "data-name": "Path 1257",
    d: "M175.725,362.307h-3.411a.779.779,0,0,1,0-1.552h3.411a.779.779,0,0,1,0,1.552Z",
    transform: "translate(-164.163 -291.118)",
    fill: "#419b46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1258",
    "data-name": "Path 1258",
    d: "M181.767,371.32h-9.453a.779.779,0,0,1,0-1.552h9.453a.779.779,0,0,1,0,1.552Z",
    transform: "translate(-164.163 -297.064)",
    fill: "#419b46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1263",
    "data-name": "Path 1263",
    d: "M7.3-.121a6.389,6.389,0,0,1,6.873,6.6,7.715,7.715,0,0,1-7.42,7.15,6.389,6.389,0,0,1-6.873-6.6A7.715,7.715,0,0,1,7.3-.121Z",
    transform: "translate(32.279 86.318) rotate(-58.134)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1259",
    "data-name": "Path 1259",
    d: "M447.994,335.676h-9.917a1.363,1.363,0,0,1-1.1-.579,1.6,1.6,0,0,1-.269-1.274,32.047,32.047,0,0,0-.15-13.69,1.586,1.586,0,0,1,.662-1.694c4.817-3.009,8.632-2.926,11.662.254a1.562,1.562,0,0,1,.4.842,52.5,52.5,0,0,1,.106,14.824,1.446,1.446,0,0,1-1.391,1.317Z",
    transform: "translate(-346.474 -261.749)",
    fill: "#419b46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1260",
    "data-name": "Path 1260",
    d: "M451.37,340.5h-3.411a.779.779,0,0,1,0-1.552h3.411a.779.779,0,0,1,0,1.552Z",
    transform: "translate(-353.859 -276.732)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1261",
    "data-name": "Path 1261",
    d: "M455.541,349.516h-7.583a.779.779,0,0,1,0-1.552h7.582a.779.779,0,0,1,0,1.552Z",
    transform: "translate(-353.859 -282.678)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolutionsImg);
export default __webpack_public_path__ + "static/media/solutionsImg.95955f6ad161edb4f23bd2e75321f011.svg";
export { ForwardRef as ReactComponent };